import { JSX } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { CapturedStamp, isReplayed } from './CapturedStamp';

/**
 * An offer to open a record in HQ.
 *
 * HQ is hash routed, so a same-origin record is one route away. Setting the hash navigates the
 * admin in place; opening a tab would reload the whole application to show it.
 */
export const OpenInHqButton: (props: { label: string, url: string, capturedAt?: number }) => JSX.Element =
    ({ label, url, capturedAt }): JSX.Element => {

        function open(): void {
            try {
                const target: URL = new URL(url, window.location.href);
                if (target.origin === window.location.origin && target.hash !== '') {
                    window.location.hash = target.hash;
                    return;
                }
                window.open(url, '_blank', 'noreferrer');
            } catch {
                // A URL that will not parse is not worth navigating to.
            }
        }

        // HQ-11. A replayed button is a record of one that was offered, not an offer. The record
        // it pointed at may have been deleted, renamed or reassigned since, so the button says
        // when it was shown and does nothing.
        if (isReplayed(capturedAt)) {
            return (
                <button type="button" className="chat__navigate is-replayed" disabled>
                    <span className="navigate__label">{ label }</span>
                    <CapturedStamp capturedAt={ capturedAt as number } />
                </button>
            );
        }

        return (
            <button type="button" className="chat__navigate" onClick={ open }>
                <span className="navigate__label">{ label }</span>
                <ArrowForwardIcon fontSize="small" />
            </button>
        );
    };
